import React from 'react';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { Col } from 'reactstrap';
import EditIcon from '@material-ui/icons/Edit';
import ActiveItemsTab from './ActiveItemsTab';
export default function ActiveItems(props) {
    return (
        <Card className="dark-card" style={{ margin: "10px", marginRight:"0px", height: 'calc(100% - 10px)' }}>
            <CardContent style={{ minHeight: '98%', maxHeight: '98%' }}>
                <ActiveItemsTab {...props} />
            </CardContent>
        </Card>
    );
}